import { STRINGS } from '../../constants';
import filterEmptyParams from '../../utils/filters';
import apiCaller from '../http';
import URLS from '../urls';

const updateWorkshopMessage = async (
  visitId,
  value,
  setError,
  setIsModalVisible,
  refreshVisitDetail,
  logoutHandler,
) => {
  const payload = { message_from_workshop: value };
  await apiCaller
    .put(`${URLS.VISIT_UPDATE_WORKSHOP_MESSAGE}${visitId}/`, filterEmptyParams(payload))
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        setIsModalVisible(false);
        refreshVisitDetail();
      } else {
        setError(STRINGS.common.error404Text);
        setIsModalVisible(false);
        refreshVisitDetail();
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
    });
};

export default updateWorkshopMessage;
